// src/components/ShareScreen.tsx
import React, { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import ProgressBar from "./ProgressBar";

const ShareScreen: React.FC = () => {
  const { nftBuyUrl, mintProgress } = useContext(AppContext);
  const navigate = useNavigate();

  if (!nftBuyUrl) {
    return <div>Error: No Buy URL available. Please complete the minting process.</div>;
  }

  const handleShare = (platform: string) => {
    alert(`Simulated sharing on ${platform}: ${nftBuyUrl}`);
  };

  const handleGoToBuyPage = () => {
    window.location.href = nftBuyUrl;
  };

  return (
    <div className="card">
      <h2>Share Your NFT</h2>
      <p>Your NFT has been minted! Here is your Buy page URL:</p>
      <p>
        <strong>{nftBuyUrl}</strong>
      </p>
      {mintProgress && (
        <ProgressBar percentage={mintProgress.percentage} estimate={mintProgress.estimate} />
      )}
      <div className="share-buttons">
        <button onClick={() => handleShare("Instagram")}>Instagram</button>
        <button onClick={() => handleShare("Twitter")}>Twitter</button>
        <button onClick={() => handleShare("Facebook")}>Facebook</button>
      </div>
      <button onClick={handleGoToBuyPage}>Go to Buy Page</button>
    </div>
  );
};

export default ShareScreen;
